import { ConnectError, Code } from '@bufbuild/connect';

export const isInvalidFileError = (error: ConnectError) =>
  error.code === Code.FailedPrecondition;
